const booleanTextMap: Record<string, boolean> = {
  yes: true,
  no: false,
};

export const mapYesNoFieldsToBoolean = (fields: Record<string, string>) => {
  try {
    const mappedFields: Record<string, boolean> = {};
    const nativeFields: Record<string, string> = {};

    Object.entries(fields).forEach(([key, value]) => {
      if (value in booleanTextMap) {
        mappedFields[key] = booleanTextMap[value];
      } else {
        nativeFields[key] = value;
      }
    });

    return {
      ...mappedFields,
      ...nativeFields,
    };
  } catch (e) {
    console.error('Error mapping yes/no fields to boolean:', e);
    return {};
  }
};

export const booleanStringToYesNo = (value: boolean | string): string => {
  if (value === true || value === 'true') return 'yes';
  if (value === false || value === 'false') return 'no';

  return '';
};

export const yesNoToBoolean = (value: string): boolean => {
  return booleanTextMap[value] ?? false;
};
